<div class="edit-business-modal-molecule-root">
  <div class="title">
    <app-label isGray class="label">{{ 'edit-business-data' | transloco }}</app-label>
    <button id="close-filter-date-icon" (click)="onCloseClick()" mat-icon-button class="close-button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div [formGroup]="formGroup" *transloco="let t">
      <app-image-upload-v1 icon="person"
                        id="edit-account-image-upload-v1"
                        [fileUploadLabel]="[t('change-company-logo'), t('change-company-logo')]"
                        [fileUploadAlt]="[t('upload-image-alt'),t('uploaded-image-alt')]"
                        [abstractControl]="getControl('picture')">
      </app-image-upload-v1>
      <form>
        <app-input  id="business-name-input"
                    [control]="getControl('name')"
                    [label]="t('business-name')"
                    required>
        </app-input>
        <app-input id="business-address-input"
                   [control]="getControl('address')"
                   [label]="t('business-address')">
        </app-input>
        <app-input id="business-number-input"
                   [control]="getControl('number')"
                   [label]="t('number')">
        </app-input>
        <app-select id="business-country-input"
                    [control]="getControl('country')"
                    [label]="t('country')"
                    required
                    [options]="countries"
                    [optionAccessor]="countryName"
                    (selectionChange)="listStates()">
        </app-select>
        <app-select id="business-state-input"
                    [control]="getControl('state')"
                    [label]="t('state')"
                    required
                    [options]="states"
                    [optionAccessor]="countryName">
        </app-select>
        <app-input id="business-postal-code-input"
                   [control]="getControl('postalCode')"
                   [label]="t('postal-code')">
        </app-input>
        <app-input id="business-phonenumber"
                   required
                   [control]="getControl('phoneNumber')"
                   [label]="t('phone-number')">
        </app-input>
        <app-select id="business-type-input"
                    [options]="businessTypes"
                    [control]="getControl('businessType')"
                    [label]="t('business-type')">
        </app-select>
        <app-input id="business-email-input"
                   [control]="getControl('email')"
                   type="email"
                   [label]="t('business-contact-email')"
                   required>
        </app-input>
        <app-input id="business-website-input"
                   [control]="getControl('website')"
                   type="url"
                   [label]="t('business-website')">
        </app-input>
      </form>
    </div>
    <div class="button-area">
      <app-primary-button class="confirm-button"
        id="confirm-edit-business-data"
        mat-button
        type="submit"
        [disabled]="isConfirmButtonDisabled() || loading"
        (clickAction)="updateBusiness()">
        {{ 'confirm' | transloco }}
      </app-primary-button>
      <app-primary-button id="close-modal-edit-business-data"
          mat-button
          (clickAction)="onCloseClick()">
          {{ 'cancel' | transloco }}
      </app-primary-button>
    </div>
  </div>
</div>
